const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let c of ca) {
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

document.addEventListener('DOMContentLoaded', () => {
  const hidePopup = getCookie('hidePopup');
  const popupWrapper = document.querySelector('.popup-wrapper');

  if (hidePopup && new Date(hidePopup) > new Date()) {
    popupWrapper.style.display = 'none';
  } else {
    popupWrapper.style.display = 'block';
  }

  document.querySelector('.cancel-link').addEventListener('click', (e) => {
    e.preventDefault();
    popupWrapper.style.display = 'none';
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 30);
    setCookie('hidePopup', futureDate, 30);
  });

  if (getCookie('hidePopup') && new Date() > new Date(getCookie('hidePopup'))) {
    popupWrapper.style.display = 'block';
  }
  if (window.location.href.includes('/challenge#popupForm')) {
    popupWrapper.style.display = 'none';
  }
  if (window.location.href.includes('?customer_posted=true')) {
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 30);
    setCookie('hidePopup', futureDate, 30);
    setTimeout(() => {
      popupWrapper.style.display = 'none';
    }, 3000);
  }
});
